// extracted by mini-css-extract-plugin
module.exports = {"rtl":"ProgressArrow-module__rtl___1IRP2","ltr":"ProgressArrow-module__ltr___G4wSc"};